// removed by extract-text-webpack-plugin
module.exports = {"submit":"_3qebK-submit","icon":"lfCgg-icon","rolling":"_2LmUl-rolling","submit_text":"_27oW--submit_text","currency":"_snn0-currency","default":"_21mI--default","material":"_3fFEo-material","ios":"Akyh1-ios"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/form-components/lib/Button/Button.scss
// module id = 794
// module chunks = 0